import { render } from "./GroceryProductCardSkeleton.vue?vue&type=template&id=afeb9e20&scoped=true"
import script from "./GroceryProductCardSkeleton.vue?vue&type=script&lang=js"
export * from "./GroceryProductCardSkeleton.vue?vue&type=script&lang=js"

import "./GroceryProductCardSkeleton.vue?vue&type=style&index=0&id=afeb9e20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afeb9e20"]])

export default __exports__